"use client";

import React from "react";
import { Link } from "react-router-dom";
import { X } from "lucide-react";

interface MobileMenuProps {
  isOpen: boolean;
  onClose: () => void;
}

const MobileMenu: React.FC<MobileMenuProps> = ({ isOpen, onClose }) => {
  // Header.tsx と必ず同じ項目にする
  const navigationItems = [
    { href: "/",            label: "Home" },
    { href: "/observatory", label: "Observatory" },
    { href: "/blog",        label: "Blog" },
    { href: "/about",       label: "About" },
  ];

  React.useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 md:hidden">
      {/* 背景オーバーレイ */}
      <div
        className="absolute inset-0 bg-black/70"
        onClick={onClose}
      />

      {/* メニューパネル */}
      <div className="relative h-full w-4/5 max-w-sm ml-auto bg-[#0a0a0a] border-l border-white/8 flex flex-col">
        {/* ヘッダー */}
        <div className="flex items-center justify-between px-6 py-4 border-b border-white/8">
          <span className="text-sm font-medium text-white">Menu</span>
          <button
            onClick={onClose}
            className="p-1.5 text-white/40 hover:text-white transition-colors focus:outline-none focus:ring-2 focus:ring-white/50 rounded"
            aria-label="メニューを閉じる"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* ナビゲーション */}
        <nav className="flex-1 overflow-y-auto px-6 py-6" aria-label="モバイルナビゲーション">
          <ul className="space-y-1">
            {navigationItems.map((item) => (
              <li key={item.href}>
                <Link
                  to={item.href}
                  onClick={onClose}
                  className="block py-2.5 text-base text-white/60 hover:text-white transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-white/50 focus:ring-offset-2 focus:ring-offset-[#0a0a0a] rounded"
                >
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </nav>

        {/* フッター */}
        <div className="px-6 py-4 border-t border-white/8">
          <p className="text-xs text-white/20">
            © {new Date().getFullYear()} TK, K.K.
          </p>
        </div>
      </div>
    </div>
  );
};

export default MobileMenu;
